import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import styles from '../ProductSnippet/productSnippet.module.css';
import Img from 'gatsby-image';

const ProductSnippet = ({ src, title, price, handle, padding }) => {
	return (
		<Col className={styles.product} xs={12} sm={6} md={3} style={{ padding: padding }}>
			<Link to={handle} className={styles.link}>
				<Img fluid={src} alt={title} />
				<p className={styles.productTitle}>{title}</p>
				{price && <p className={styles.price}>€ {price}</p>}
			</Link>
		</Col>
	);
};

export default ProductSnippet;
